import { useState } from 'react';

import Grid from '../../OC/PageBuilder/Grid';

const Result = ({
  result,
  resultComponent,
  resultHeaderComponent,
  resultComponentStyle,
  resultGridSize = 3,
  appliedFilters,
  locale,
  showLogo = false,
}) => {
  const [collapsed, setCollapsed] = useState(false);

  const Component = resultComponent;
  const Header = resultHeaderComponent;
  const header = result.data.length > 0 && Header && <Header headerData={result.headerData} />;

  return (
    <>
      {resultComponentStyle === 'grid' ? (
        <Grid selectedSize={resultGridSize}>
          {header}
          {!collapsed &&
            result.data.map((item, index) => (
              <Component key={index} appliedFilters={appliedFilters} locale={locale} {...item} />
            ))}
        </Grid>
      ) : (
        <>
          {header}
          {!collapsed &&
            result.data.map((item, index) => (
              <Component key={index} appliedFilters={appliedFilters} locale={locale} showLogo={showLogo} {...item} />
            ))}
        </>
      )}
    </>
  );
};
export default Result;
